/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2019 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import React from 'react';

import IllustratedMessage from '@react/react-spectrum/IllustratedMessage';
import Wait from '@react/react-spectrum/Wait';

import spinnerStyle from './styles/centered-spinner.styl';

export default (loading, illustratedMessageProps) => () => (
  <React.Fragment>
    { loading ? (
      <Wait
        className={spinnerStyle['centered-spinner-large']}
        size="L"
      />
    ) : (
      <IllustratedMessage {...illustratedMessageProps} />
    )}
  </React.Fragment>
);
